import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'devices/navigation';
import withDeviceData from 'appAssets/hocs/WithDeviceData';
import DeviceStatusWidget from './DeviceStatusWidget';

const DeviceWidget = ({
  deviceData, parentId, source, tooltipPermission, withSimcard, withInstallation,
}) => {
  if (deviceData) {
    const statusWidgetProps = {
      device: deviceData,
      source,
      parentId,
      tooltipPermission,
      withDesc: true,
      withSimcard,
      withInstallation,
    };
    return (
      <OnlyWith
        permissions={{
          needed: permissions.pDevice.read,
          permissionsOrContext: 'devicePermissions',
        }}
        alternativeComponent={<DeviceStatusWidget {...statusWidgetProps} />}
      >
        <Link to={showPath(deviceData.id)}>
          <DeviceStatusWidget {...statusWidgetProps} />
        </Link>
      </OnlyWith>
    );
  }
  return null;
};

DeviceWidget.propTypes = {
  device: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired, // eslint-disable-line react/no-unused-prop-types
  deviceData: deviceDataShape,
  parentId: PropTypes.number,
  source: PropTypes.oneOf(['installation', 'simcard', 'deviceSlave']).isRequired,
  tooltipPermission: PropTypes.object,
  withSimcard: PropTypes.bool,
  withInstallation: PropTypes.bool,
};

DeviceWidget.defaultProps = {
  deviceData: null,
  parentId: 0,
  tooltipPermission: null,
  withSimcard: false,
  withInstallation: false,
};

module.exports = withDeviceData('device.id')(DeviceWidget);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceWidget.js